
import { isNullOrUndefined } from 'util';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

declare var $: any;
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../../../services/seguridad/auth.service';

import { EntidadService } from '../../../services/entity/entidad.service';
import { Entidad } from 'src/app/models/entidad';
import { Asociacion, AsociacionReport } from 'src/app/models/asociacion';

import { IdiomaService } from '../../../services/administracion/idioma.service';
import { Idioma } from 'src/app/models/idioma';

import { DetalleEntidadService } from '../../../services/entity/detalle-entidad.service';
import { DetalleEntidad } from 'src/app/models/detalle-entidad';


import { TipoAsociacionService } from '../../../services/administracion/tipo-asociacion.service';
import { TipoEntidadService } from '../../../services/administracion/tipo-entidad.service';
import { TipoEntidad } from 'src/app/models/tipo-entidad';

// Servicio de captura error implementado por mi
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { TipoAsociacion } from 'src/app/models/tipo-asociacion';
import { AsociacionService } from 'src/app/services/entity/asociacion.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-relaciones',
  templateUrl: './relaciones.component.html',
  styleUrls: ['./relaciones.component.css']
})
export class RelacionesComponent implements OnInit {

  // para cargar evaluacion
  IdEntidadSeleccionada = 0;
  EntidadSeleccionada = '';
  EstadoEntidad = 0;
  EvaluacionEntidad = 0;
  CountEntidad = 0;
  ComentarioEntidad = '';
  ASOCIACION: Asociacion;
  Search: string = '';

  transaccionIsNew = true;
  asociar = false;
  ROW_NUMBER: number;
  dialogTittle = 'Nuevo';

  // DataTable --
  dataSource: MatTableDataSource<Asociacion>;
  displayedColumns = ['IdAsociacion', 'IdEntidad1', 'IdEntidad2', 'TipoAsociacion'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ListAsociacionReport: AsociacionReport[] = [];
  listEntidadesAux: Asociacion[];
  listEntidades: MatTableDataSource<Asociacion>;
  listIDS: Array<number> = [];
  listIdiomas: Idioma[];
  dataSourceDetalle: MatTableDataSource<DetalleEntidad>;

  listTipoAsociacion: TipoAsociacionService[];
  listTiposEntidad: TipoEntidad[];
  dataSourceDetallePalabras: MatTableDataSource<DetalleEntidad>;
  pageIndex = 1;
  pageSize = 10;
  filterValue = '';

  constructor(
    private Service: AsociacionService,
    private entidadService: EntidadService,
    private tipoAsociacionService: TipoAsociacionService,
    private detalleEntidadService: DetalleEntidadService,
    private authService: AuthService,
    private idiomaService: IdiomaService,
    private tipoEntidadService: TipoEntidadService,
    private errorService: ErrorHandlerService,
    private excelService: ExcelService,
    private router: Router,
    private snackBar: MatSnackBar,
    private _location: Location
  ) { }

  ngOnInit() {
    this.IdEntidadSeleccionada = this.Service.form.value.IdEntidad1;
    this.EntidadSeleccionada = this.Service.form.value.entidadSelecionada;

    this.paginator._intl.itemsPerPageLabel = 'Registros por página';
    this.paginator._intl.previousPageLabel = 'Anterior';
    this.paginator._intl.nextPageLabel = 'Siguiente';
    this.paginator._intl.firstPageLabel = 'Primero';
    this.paginator._intl.lastPageLabel = 'Último';
    this.CargarDgvElements(this.pageIndex, this.pageSize, this.filterValue);
    this.CargarSelects();
  }

  CargarDetalles() {
    this.detalleEntidadService.get().subscribe(result => {
      this.dataSourceDetalle = new MatTableDataSource<DetalleEntidad>(result.data);
      this.dataSourceDetallePalabras = new MatTableDataSource<DetalleEntidad>(result.data);

    }, (error) => {

    });
  }


  CargarSelects() {

    this.tipoEntidadService.get().subscribe(result => {
      this.listTiposEntidad = result.data;
    });
  }

  CargarDgvElements(pageIndex: number, pageSize: number, filterValue: string) {

    // if (this.authService.currentUser.Rol === 'Estudiante') {
    this.Service.getRelaciones(pageIndex, pageSize, filterValue).subscribe(result => {
      console.log(result.data)
      this.dataSource = new MatTableDataSource<Asociacion>(result.data);
      this.listEntidades = new MatTableDataSource<Asociacion>(result.totalData);
      this.paginator.length = result.totalCount;
      
      //this.CargarDetalles();
    }, (error) => {
      this.errorService.handleError(error);
    });

    /*
  }
  else {
    this.Service.getByIdEntidadEvaluada(this.IdEntidadSeleccionada).subscribe(result => {
      this.dataSource = new MatTableDataSource<Asociacion>(result.data);
      this.listEntidades = result.data;
      this.dataSource.paginator = this.paginator;
      this.CargarDetalles();
    }, (error) => {
      this.errorService.handleError(error);
    });
  }
*/

  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.CargarDgvElements(this.pageIndex + 1 , this.pageSize, this.filterValue);
  }


  Descargar() {
    this.listEntidades.filteredData.forEach(item => {
      if (item['Estado'] == '1') {
        var asociacionReport = {
          IdAsociacion: item['IdAsociacion'],
          IdEntidad1: item['IdEntidad1'],
          IdEntidad2: item['IdEntidad2'],
          IdTipoAsociacion: item['IdTipoAsociacion'],
          TipoAsociacion: item['TipoAsociacion'],
          Descripcion: item['Descripcion'],
          Nivel: item['Nivel']
        };
        this.ListAsociacionReport.push(asociacionReport);
      }
    });
    this.excelService.exportAsExcelFile(this.ListAsociacionReport, 'Relaciones');
  }

}


